// Cross-portal URLs the landing page links to. Resolved at build time
// so the same image works across dev/staging/prod when VITE_* are set;
// in dev we fall back to .play.local hosts.
const ROOT = import.meta.env.VITE_ROOT_DOMAIN ?? 'play.local';
const SCHEME = ROOT.endsWith('.local') ? 'http' : 'https';

export const ADVERTISER_URL = `${SCHEME}://advertiser.${ROOT}`;
export const ADVERTISER_REGISTER_URL = `${ADVERTISER_URL}/register`;
export const ADVERTISER_LOGIN_URL = `${ADVERTISER_URL}/login`;
export const PLAYER_URL = `${SCHEME}://play.${ROOT}`;
